import { t } from 'i18next';
import { comments, history, relatedTo } from '@/components/icons/icons';
import { PageAction, PageTab } from './types';
import { FormMode } from '@/components/forms/types';
import { BaseItemDto, getDefaultActions } from '@/utils/actions';
import { TabDefinition } from '@/components/Tabs/types';

export const defaultPageTabs = {
  administrative: {
    get title() {
      return t('AdministrativeInformation');
    },
  },
  configuration: {
    get title() {
      return t('Configuration');
    },
  },
  comments: {
    icon: comments,
    get title() {
      return t('Comments');
    },
  },
  related: {
    icon: relatedTo,
    get title() {
      return t('Related');
    },
  },
  history: {
    icon: history,
    hidden: true,
    hideContentSheet: true,
    get title() {
      return t('History');
    },
  },
} satisfies TabDefinition<PageTab>;

export function getDefaultPageActions(
  mode: FormMode,
  item?: BaseItemDto,
): Record<string, PageAction> {
  return getDefaultActions(mode, item);
}
